"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageEventContentType = exports.AdsAgentChatEventType = void 0;
// Base event types
var AdsAgentChatEventType;
(function (AdsAgentChatEventType) {
    AdsAgentChatEventType["PAGE_ACTION"] = "A3C_PAGE_ACTION";
    AdsAgentChatEventType["CHAT_SEND_MESSAGE"] = "A3C_CHAT_SEND_MESSAGE";
    AdsAgentChatEventType["CHAT_LOADED"] = "A3C_CHAT_LOADED";
})(AdsAgentChatEventType || (exports.AdsAgentChatEventType = AdsAgentChatEventType = {}));
var MessageEventContentType;
(function (MessageEventContentType) {
    MessageEventContentType["SQL"] = "sql";
    MessageEventContentType["PLAIN_TEXT"] = "PlainText";
})(MessageEventContentType || (exports.MessageEventContentType = MessageEventContentType = {}));
//# sourceMappingURL=types.js.map